import { createFocusTrap } from '../../node_modules/focus-trap/dist/focus-trap.esm.js'
import PhotoSwipeLightbox from '../../node_modules/photoswipe/dist/photoswipe-lightbox.esm.js'
import PhotoSwipe from '../../node_modules/photoswipe/dist/photoswipe.esm.js'

const customGoTo = (index, animate = false) => {
	const ctx = lightbox.pswp
	index = ctx.getLoopedIndex(index)
	const indexChanged = ctx.mainScroll.moveIndexBy(
		index - ctx.potentialIndex,
		animate
	)

	if (indexChanged) {
		ctx.dispatch('afterGoto')
	}
}

const leftArrowSVGString =
	'<svg height="32" viewBox="0 0 32 32" width="32" xmlns="http://www.w3.org/2000/svg"><path d="m148.300964 58.8095908 5.816108-5.523274c.401995-.3817557 1.052031-.3817557 1.44975 0l.9665.9178382c.401996.3817557.401996.9990627 0 1.3767572l-4.118317 3.9190878 4.122594 3.9150266c.401995.3817557.401995.9990627 0 1.3767572l-.9665.9218994c-.401996.3817557-1.052032.3817557-1.449751 0l-5.816107-5.523274c-.406272-.3817557-.406272-.9990627-.004277-1.3808184z" fill-rule="evenodd" transform="translate(-138 -44)"/></svg>'
const rightArrowSVGString =
	'<svg height="32" viewBox="0 0 32 32" width="32" xmlns="http://www.w3.org/2000/svg"><path d="m106.300964 58.8095908 5.816108-5.523274c.401995-.3817557 1.052031-.3817557 1.44975 0l.9665.9178382c.401996.3817557.401996.9990627 0 1.3767572l-4.118317 3.9190878 4.122594 3.9150266c.401995.3817557.401995.9990627 0 1.3767572l-.9665.9218994c-.401996.3817557-1.052032.3817557-1.449751 0l-5.816107-5.523274c-.406272-.3817557-.406272-.9990627-.004277-1.3808184z" fill-rule="evenodd" transform="matrix(-1 0 0 1 126.839096 -44)"/></svg>'
const closeSVGString =
	'<svg height="32" viewBox="0 0 32 32" width="32" xmlns="http://www.w3.org/2000/svg"><path d="m18.2745455 16 3.4114772-3.4114773c.4186364-.4186363.4186364-1.0973863 0-1.5163636l-.7581819-.7581818c-.4186363-.41863642-1.0973863-.41863642-1.5163636 0l-3.4114772 3.4114772-3.4114773-3.4114772c-.4186363-.41863642-1.0973863-.41863642-1.5163636 0l-.7581818.7581818c-.41863642.4186364-.41863642 1.0973864 0 1.5163636l3.4114772 3.4114773-3.4114772 3.4114772c-.41863642.4186364-.41863642 1.0973864 0 1.5163636l.7581818.7581819c.4186364.4186364 1.0977273.4186364 1.5163636 0l3.4114773-3.4114772 3.4114772 3.4114772c.4186364.4186364 1.0977273.4186364 1.5163636 0l.7581819-.7581819c.4186364-.4186363.4186364-1.0973863 0-1.5163636z"/></svg>'

const lightbox = new PhotoSwipeLightbox({
	gallery: 'body',
	children: '.c-figure__link',
	showHideAnimationType: 'zoom',
	arrowNextSVG: rightArrowSVGString,
	arrowPrevSVG: leftArrowSVGString,
	zoom: false,
	closeSVG: closeSVGString,
	bgOpacity: 0.9,
	pswpModule: PhotoSwipe,
	paddingFn: (viewportSize) => ({
		top: 64,
		bottom: 64,
		left: 64,
		right: 64,
	}),
	mainClass: 'c-pswp',
	errorMsg: 'Se ha producido un error al cargar la imagen',
})
lightbox.init()

lightbox.on('uiRegister', () => {
	lightbox.pswp.next = () => customGoTo(lightbox.pswp.potentialIndex + 1, true)
	lightbox.pswp.prev = () => customGoTo(lightbox.pswp.potentialIndex - 1, true)

	lightbox.pswp.ui.registerElement({
		name: 'custom-caption',
		order: 9,
		isButton: false,
		appendTo: 'root',
		html: 'Caption text',
		onInit: (el, pswp) => {
			lightbox.pswp.on('change', () => {
				const currSlideElement =
					lightbox.pswp.currSlide.data.element.closest('figure')
				let captionHTML = ''
				if (currSlideElement) {
					const hiddenCaption =
						currSlideElement.querySelector('.c-figure__caption')
					if (hiddenCaption) {
						// get caption from element with class hidden-caption-content
						captionHTML = hiddenCaption.innerHTML
					} else {
						// get caption from alt attribute
						captionHTML = currSlideElement
							.querySelector('img')
							.getAttribute('alt')
					}
				}
				el.innerHTML = captionHTML || ''
			})
		},
	})
})

let galleryFocusTrap

// Enable focus trap on gallery open
lightbox.on('openingAnimationStart', () => {
	galleryFocusTrap = createFocusTrap('.pswp__scroll-wrap')
	galleryFocusTrap.activate()
})

// Disable focus trap on gallery close
lightbox.on('close', () => {
	galleryFocusTrap.deactivate()
})
